const CLEVER_TAP_CONSTANT = {
	EVENTS_NAME: {
		LANDING: 'landing',
		GV: {
			GV_C1_BANNER_CLICK: 'GV_C1_Banner_click',
			GV_TILE_CLICK: 'GV_tile_click',
		},
		GENERAL: {
			FAQ: 'faq',
			DETAILED_FAQ: 'detailed faq',
			CASHBACK: 'cashback',
			REFER_N_EARN: 'refernearn',
			TNC: 'tnc',
			REFERRAL_CONTACT_LIST: 'referred contact list',
		},
		ONBOARDING_FLOW: {
			BANK_LIST: 'bank list',
			ENTER_PAN: 'enter pan',
			LOAN_SANCTION: 'loan sanction',
			TOP_BANKS: 'top banks',
			WAITLIST: 'ineligible',
			PAN_FETCH: 'pan fetch',
		},
		POSTPAID_FLOW: {
			COMING_SOON: 'coming soon',
			AMOUNT_INSERTION: 'amount insertion',
			AGREEMENT: 'agreement',
			EMI_CONVERSION: 'emi conversion',
			HOME: 'home',
			MERCHANT_BANKS: 'merchant bank selection',
			MERCHANT_MOBILE: 'merchant mobile insertion',
			PROFILE: 'profile',
			BILL_VIEW: 'bill view',
		},
		PREPAID_FLOW: {
			ADD_MONEY: 'add money',
			AGREEMENT: 'agreement',
			AMOUNT_INSERTION: 'amount insertion',
			HOME: 'home',
			COMING_SOON: 'coming soon',
			PROFILE: 'profile',
			MERCHANT_BANKS: 'merchant bank selection',
			MERCHANT_MOBILE: 'merchant mobile insertion',
		},
		RECEIVE_LIMIT_FLOW: {
			HOME: 'home',
			AMOUNT_INSERTION: 'amount insertion',
			COMING_SOON: 'coming soon',
			MERCHANT_BANKS: 'merchant bank selection',
			MERCHANT_MOBILE: 'merchant mobile insertion',
			PROFILE: 'profile',
		},
		TRANSACTION_FLOW: {
			LIST: 'transaction list',
			STATUS: 'transaction status',
		},
		SEND_MONEY_FLOW: {
			HOME: 'home',
			BANK_LIST: 'sm bank list',
			TOP_BANKS: 'sm top banks',
			OWN_BANKS: 'fetched banks',
			AMOUNT_INSERTION: 'amount insertion',
		},
		ORDER_CARD_FLOW: {
			DELIVERY_STATUS: 'delivery status',
			ENTER_ADDRESS: 'enter address',
			LANDING: 'landing',
		},
		MANDATORY_EVENTS: {
			CARD_USER: 'card user',
			ACCOUNT_CREATED: 'account created',
			PAN_VERIFIED: 'pan verification success',
			BANK_VERIFIED: 'bank verification success',
			KYC_VERIFIED: 'kyc success',
			INELIGIBLE: 'ineligible',
			ELIGIBLE: 'eligible',
			FIRST_TRANSACTION_SUCCESS: 'first txn success',
			TRANSACTION_SUCCESS: 'txn success',
		},
		SCRATCH_CARD: 'scratch card',
	},
	EVENTS_PARAMS: {
		LANDING: {
			PAGE_LANDING: 'page landing',
		},
		GENERAL: {
			FAQ: {
				PAGE_LANDING: 'page landing',
				FAQ_CLICKED: 'faq',
			},
			DETAILED_FAQ: {
				PAGE_LANDING: 'page landing',
				DETAILED_FAQ_CLICKED: 'detailed faq',
			},
			CASHBACK: {
				PAGE_LANDING: 'page landing',
				EARN_MORE_CLICKED: 'earn more',
			},
			REFER_N_EARN: {
				PAGE_LANDING: 'page landing',
				COPY_LINK_CLICKED: 'copy link',
				SHARE_CLICKED: 'share',
				TNC_CLICKED: 'tnc',
			},
			TNC: {
				PAGE_LANDING: 'page landing',
				RESPECTIVE_TNC: 'respective tnc',
			},
			REFERRAL_CONTACT_LIST: {
				PAGE_LANDING: 'page landing',
			},
		},
		ONBOARDING_FLOW: {
			BANK_LIST: {
				PAGE_LANDING: 'page landing',
				BANK_SELECTED: 'bank selected',
				BANK_VERIFICATION_FAILED: 'bank verification failed',
			},
			ENTER_PAN: {
				PAGE_LANDING: 'page landing',
				PAN_ENTERED: 'pan entered',
				PAN_VERIFICATION_FAILED: 'pan verification failed',
			},
			LOAN_SANCTION: {
				PAGE_LANDING: 'page landing',
			},
			TOP_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECTED: 'bank selected',
				MORE_BANKS: 'more banks',
				BANK_VERIFICATION_FAILED: 'bank verification failed',
			},
			WAITLIST: {
				PAGE_LANDING: 'page landing',
				VIEW_REFERRALS: 'view referrals',
				CONTACTS_SELECTED: 'contacts selected',
				REFER_COPY_LINK: 'refer_copylink_clicked',
				REFER_CLICKED: 'refer_clicked',
			},
			PAN_FETCH: {
				CLICKED_PAN_FETCH: 'clicked_pan_fetch',
				PAN_FETCHED_INITIATED: 'pan_fetched_initiated',
				PAN_FETCHED_SUCCESSFULLY: 'pan_fetched_successfully',
			},
		},
		POSTPAID_FLOW: {
			COMING_SOON: {
				PAGE_LANDING: 'page landing',
			},
			AMOUNT_INSERTION: {
				PAGE_LANDING: 'page landing',
				AMOUNT_INSERTED: 'amount inserted',
			},
			AGREEMENT: {
				PAGE_LANDING: 'page landing',
				AGREEMENT_SIGNED: 'agreement signed',
			},
			EMI_CONVERSION: {
				PAGE_LANDING: 'page landing',
				EMI_CONVERTED: 'emi converted',
				PAY_NOW: 'pay now',
			},
			HOME: {
				PAGE_LANDING: 'page landing',
				BILL_PAY: 'bill pay',
				ACCOUNT_BALANCE_VIEW: 'account balance view',
				CARD_OPENED: 'card opened',
				TRANSACTIONS_CLICKED: 'all transactions',
				CARD_ORDER_OPENED: 'card order',
				QR_SCAN: 'qr scan',
				TAB_CLICKED: 'tab clicked',
				KYC_CLICKED: 'kyc clicked',
				EARNINGS_CLICKED: 'earnings',
				REFERNEARN_CLICKED: 'refernearn',
				POSTPE_TXN_STOP_MODAL: 'postpe_transaction_stop_modal',
			},
			MERCHANT_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECT: 'bank selected',
			},
			MERCHANT_MOBILE: {
				PAGE_LANDING: 'page landing',
				MOBILE_ENTERED: 'mobile entered',
			},
			ORDER_CARD: {
				LANDING: {
					PAGE_LANDING: 'page landing',
					CONTINUE: 'continue',
				},
				ENTER_ADDRESS: {
					PAGE_LANDING: 'page landing',
					ADDRESS_ENTERED: 'address entered',
					KYC_OPENED: 'kyc opened',
				},
				DELIVERY_STATUS: {
					PAGE_LANDING: 'page landing',
					CARD_OPENED: 'card opened',
				},
			},
			PROFILE: {
				PAGE_LANDING: 'page landing',
				OPTIONS_CLICKED: 'options clicked',
			},
			BILL_VIEW: {
				PAGE_LANDING: 'page landing',
				PAY_NOW: 'pay now',
				CONVERT_TO_EMI: 'emi convert',
			},
		},
		PREPAID_FLOW: {
			COMING_SOON: {
				PAGE_LANDING: 'page landing',
			},
			AMOUNT_INSERTION: {
				PAGE_LANDING: 'page landing',
				AMOUNT_INSERTED: 'amount inserted',
			},
			AGREEMENT: {
				PAGE_LANDING: 'page landing',
				AGREEMENT_SIGNED: 'agreement signed',
			},
			HOME: {
				PAGE_LANDING: 'page landing',
				CARD_OPENED: 'card opened',
				TRANSACTIONS_CLICKED: 'all transactions',
				CARD_ORDER_OPENED: 'card order',
				QR_SCAN: 'qr scan',
				TAB_CLICKED: 'tab clicked',
				EARNINGS_CLICKED: 'earnings',
				KYC_CLICKED: 'kyc clicked',
			},
			MERCHANT_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECT: 'bank selected',
			},
			MERCHANT_MOBILE: {
				PAGE_LANDING: 'page landing',
				MOBILE_ENTERED: 'mobile entered',
			},
			PROFILE: {
				PAGE_LANDING: 'page landing',
				OPTIONS_CLICKED: 'options clicked',
			},
		},
		RECEIVE_LIMIT_FLOW: {
			COMING_SOON: {
				PAGE_LANDING: 'page landing',
			},
			AMOUNT_INSERTION: {
				PAGE_LANDING: 'page landing',
				AMOUNT_INSERTED: 'amount inserted',
			},
			HOME: {
				PAGE_LANDING: 'page landing',
				ACCOUNT_BALANCE_VIEW: 'account balance view',
				CARD_OPENED: 'card opened',
				TRANSACTIONS_CLICKED: 'all transactions',
				CARD_ORDER_OPENED: 'card order',
				QR_SCAN: 'qr scan',
				TAB_CLICKED: 'tab clicked',
				KYC_CLICKED: 'kyc clicked',
			},
			MERCHANT_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECT: 'bank selected',
			},
			MERCHANT_MOBILE: {
				PAGE_LANDING: 'page landing',
				MOBILE_ENTERED: 'mobile entered',
			},
			PROFILE: {
				PAGE_LANDING: 'page landing',
				OPTIONS_CLICKED: 'options clicked',
			},
		},
		TRANSACTION_FLOW: {
			STATUS: {
				PAGE_LANDING: 'page landing',
				EARN_MORE_CLICKED: 'earn more',
				RATE: 'rate',
				SCRATCH_CARD_OPENED: 'transaction status|opened',
				SCRATCH_CARD_SCRATCHED: 'transaction status|scratched',
			},
			LIST: {
				PAGE_LANDING: 'page landing',
				TRANSACTION_CLICKED: 'transaction view',
			},
		},
		SEND_MONEY_FLOW: {
			HOME: {
				PAGE_LANDING: 'page landing',
				MOBILE_SELECTED: 'mobile selected',
				BANK_SELECTED: 'bank selected',
			},
			BANK_LIST: {
				PAGE_LANDING: 'page landing',
				BANK_SELECTED: 'bank selected',
				BANK_VERIFICATION_FAILED: 'bank verification failed',
			},
			TOP_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECTED: 'bank selected',
				MORE_BANKS: 'more banks',
				BANK_VERIFICATION_FAILED: 'bank verification failed',
			},
			OWN_BANKS: {
				PAGE_LANDING: 'page landing',
				BANK_SELECTED: 'bank selected',
			},
			AMOUNT_INSERTION: {
				PAGE_LANDING: 'page landing',
				AMOUNT_INSERTED: 'amount inserted',
			},
		},
		ORDER_CARD_FLOW: {
			LANDING: {
				PAGE_LANDING: 'page landing',
				CONTINUE: 'continue',
			},
			ENTER_ADDRESS: {
				PAGE_LANDING: 'page landing',
				ADDRESS_ENTERED: 'address entered',
				KYC_OPENED: 'kyc opened',
			},
			DELIVERY_STATUS: {
				PAGE_LANDING: 'page landing',
				CARD_OPENED: 'card opened',
			},
		},
	},
};

export default CLEVER_TAP_CONSTANT;
